import { useCallback, useMemo } from 'react';
import { Location, NavigateOptions, To, useLocation, useNavigate } from 'react-router';

import { Page, routers } from '@src/config/router.config';

function useNav() {
  const navigate = useNavigate();

  const location = useLocation() as unknown as (Location & { getSearchParams: () => URLSearchParams });

  location.getSearchParams = () => new URLSearchParams(location.search);

  const to = useCallback((to: string | Page, options: NavigateOptions & { search?: string | Record<string, string> } = {}) => {
    const defaultState = {
      $prev: window.location.pathname,
    };
    let path = '';
    if (typeof to === 'string') {
      // 可能是path 或者 路由名称 name
      const router = routers.find((item) => item.name === to);
      path = router?.path || to;
    } else {
      path = to.path;
    }
    if (options.search) {
      const query = options?.search;
      let queryStr = '';
      if (typeof query === 'string') {
        queryStr = query;
      } else {
        queryStr = `?${new URLSearchParams(query).toString()}`;
      }

      path = `${path}${queryStr}`;
    }
    options.state = { ...defaultState, ...options.state };
    return navigate(path as To, options);
  }, [navigate]);
  const nav = useMemo(() => ({
    location,
    /** path or name */
    to,
    back: () => navigate(-1),
  }), [location, to, navigate]);
  return nav;
}

export default useNav;